import React, { useState, useEffect } from "react";
 
const carouselData = [
  { id: 0, 
    title: "Research & Development", 
    subtitle: "AI-powered Integrated Fleet Management →", 
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/R%26D.jpg" },

  { id: 1, 
    title: "Object Detection & Tracking", 
    subtitle: "YOLO, Faster R-CNN for vehicles, people, wildlife →", 
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/Drone.jpeg" },
  { id: 2, 
    title: "Autonomous Navigation & Collision Avoidance", 
    subtitle: "Satellite Operations & Earth Analytics Platform →", 
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/autonomos-navigation.jpg" },
  { id: 3, 
    title: "Edge Computing", 
    subtitle: "AI-Powered Data Center Operations Platform →", 
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/edge.jpg.jpeg" },
  { id: 4, 
    title: "IoT Integration", 
    subtitle: "Smart Skyscraper AI Management Platform →", 
    image: "https://blackroth-images.s3.ap-south-1.amazonaws.com/IoT.jpg" }
];
 
const Carousel = () => {
  const [activeTab, setActiveTab] = useState(0);
 
  const goToPrevious = () =>
    setActiveTab(prev => (prev > 0 ? prev - 1 : carouselData.length - 1));
 
  const goToNext = () =>
    setActiveTab(prev => (prev < carouselData.length - 1 ? prev + 1 : 0));
 
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTab(prev => (prev + 1) % carouselData.length);
    }, 5000);
 
    return () => clearInterval(interval);
  }, []);
 
  return (
<div className="palantir-carousel-container">
      <div className="carousel slide">
<div className="carousel-tabs">
          {carouselData.map((item, index) => (
<button
              type="button"
              key={item.id}
              className={`carousel-tab ${activeTab === index ? "active" : ""}`}
              onClick={() => setActiveTab(index)}
>
              {item.title}
</button>
          ))}
</div>
<div className="carousel-inner">
          {carouselData.map((item, index) => (
<div
              key={item.id}
              className={`carousel-item ${activeTab === index ? "active" : ""}`}
              style={{ display: activeTab === index ? "block" : "none" }}
>
<img
  src={item.image}
  alt={item.title}
  className={`d-block w-100 ${
    item.id === 1 ? "object-detection-slide-image" : ""
  }`}
/>
</div>
          ))}
</div>
 
        <button onClick={goToPrevious} className="carousel-control-prev">Prev</button>
<button onClick={goToNext} className="carousel-control-next">Next</button>
</div>
</div>
  );
};
 
export default Carousel;
